import { cn } from '../../lib/classNameHelpers';

const animationStyles = {
  wave: 'before:absolute before:inset-0 before:-translate-x-full before:animate-wave before:bg-gradient-to-r before:from-transparent before:via-white/10 before:to-transparent',
  pulse: 'animate-pulse',
} as const;

type SkeletonAnimation = keyof typeof animationStyles;

type SkeletonProps = React.HTMLAttributes<HTMLDivElement> & {
  animation?: SkeletonAnimation;
};

export function Skeleton({ className, animation = 'wave', ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded bg-backgroundTertiary',
        animationStyles[animation],
        className
      )}
      {...props}
    />
  );
}
